import styled, { css } from 'styled-components';
import { colors, subtleShadow } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';
import { pxToRem } from 'utils/convert';

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

const SkeletonCard = styled.div`
  ${flexColumn}
  align-items: flex-start;
  padding: ${pxToRem(12)};
  padding-left: ${pxToRem(36)};
  gap: ${pxToRem(3)};
  width: ${pxToRem(352)};
  height: ${pxToRem(154)};
  background: ${colors.white};
  border-radius: ${pxToRem(8)};
  ${subtleShadow}
`;

const CardBadgeWrapper = styled.div`
  position: absolute;
  top: ${pxToRem(4)};
  left: -${pxToRem(25)};
`;

const CardTop = styled.div`
  position: relative;
`;

const CardBody = styled.div`
  ${flexColumn}
  gap: ${pxToRem(3)};
`;

const CardBottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: ${pxToRem(304)};
`;

const StyledSkeleton = styled(Skeleton)`
  border-radius: ${pxToRem(100)};
`;

const SkeletonBadge = styled(Skeleton)`
  border-radius: 100%;

  & div {
    background: linear-gradient(
      90deg,
      transparent ${pxToRem(4)},
      ${colors.grey5} ${pxToRem(8)},
      ${colors.grey1} ${pxToRem(16)}
    );
  }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
  height: calc(100vh - 9.5rem);
  background-color: ${colors.grey1};
`;

export const NotificationSkeleton = () => {
  return (
    <SkeletonCard>
      <CardTop>
        <CardBadgeWrapper>
          <SkeletonBadge shimmerSpeed={3000} width={16} height={16} />
        </CardBadgeWrapper>
        <StyledSkeleton width={304} height={24} />
      </CardTop>
      <CardBody>
        <StyledSkeleton width={264} height={20} />
        <StyledSkeleton width={208} height={20} />
        <StyledSkeleton width={169} height={20} />
      </CardBody>
      <CardBottom>
        <StyledSkeleton width={103} height={20} /> <StyledSkeleton width={103} height={20} />
      </CardBottom>
    </SkeletonCard>
  );
};
